export default __webpack_public_path__ + "static/media/AuthApp.1dd4dce7.PNG";